import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import { Row, Col, Container, Input, Table } from 'reactstrap';
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//constant
import { homePageUrl } from '../../../helpers/Constants';

function ClientTable() {

    let [isChecked, setIsChecked] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
   
    const handleOnChange = () => {
        setIsChecked(!isChecked);
      };


  return (
    <section className='lyt-section'>
        <Container fluid className='typ-container'>
            <div className='bs-card'>
                <Row>
                    {isChecked ? (
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className='bs-action-btn'>
                                <div className='button-group'>
                                <a className='action-btn' href=""> <span class="icon icon-download"></span></a>
                                <a className='action-btn' href=""> <span class="icon icon-share"></span></a>
                                <a className='action-btn' href=""><span class="icon icon-delete"></span></a>
                                </div>
                            </div>     
                        </Col>  
                        ) :  (
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className='bs-table'>
                                <div className='main-header'>
                                    <form className='bs-form'>
                                        <div className='search-btn'>
                                            <Input type='text' placeholder='Search...' />
                                            <i className='icon icon-search'></i>
                                        </div>
                                        <div className='dropdown-bx'>
                                            <label className='form-label'>Company Name :  </label>
                                            <Input  type="select" name="select" id="exampleSelect">
                                                <option>HDFC</option>
                                                <option>Yearly</option>
                                                <option>3</option>
                                                <option>4</option>
                                                <option>5</option>
                                            </Input>
                                        </div>
                                        <div className='dropdown-bx report-date'>
                                            <label className='form-label'>Date : </label>
                                            {/* <Input type="text" name="text" id="exampleEmail" className='cstm-input' placeholder="Enter Branch ID" /> */}
                                            <DatePicker selected={startDate} onChange={(date:Date) => setStartDate(date)} placeholderText="date"  className='typ-date'/>
                                        </div>    
                                        <div className='dropdown-bx'>
                                            <label className='form-label'>Branch ID : </label>
                                            <Input  type="select" name="select" id="exampleSelect">
                                                <option>HDFC</option>
                                                <option>Yearly</option>
                                                <option>3</option>
                                                <option>4</option>
                                                <option>5</option>
                                            </Input>
                                        </div> 
                                    </form>
                                </div>
                            </div>     
                        </Col> 
                    )}
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className='bs-table'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th><Input type="checkbox" />{' '}</th>
                                        <th>Sr.No.</th>
                                        <th>Company <span className='d-block'>Name</span></th>
                                        <th>Branch_ID </th>
                                        <th>Office Address</th>
                                        <th>Branch POC Number</th>
                                        <th>Assigned Compliancer <span className='d-block'>Officer</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                        <td>1</td>
                                        <td>HDFC</td>
                                        <td>HDFC_Worli &nbsp; <NavLink className="text-decoration-none"><i className='icon icon-eye'></i></NavLink></td>
                                        <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                        <td>Ramesh_91123456789</td>
                                        <td>Saloni Parihar</td>           
                                    </tr>
                                    <tr>
                                        <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                        <td>2</td>
                                        <td>HDFC</td>
                                        <td>HDFC_Worli &nbsp; <NavLink className="text-decoration-none"><i className='icon icon-eye'></i></NavLink></td>
                                        <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                        <td>Ramesh_91123456789</td>
                                        <td>Saloni Parihar</td>   
                                    </tr>
                                    <tr>
                                        <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                        <td>3</td>
                                        <td>HDFC</td>
                                        <td>HDFC_Worli &nbsp; <NavLink className="text-decoration-none"><i className='icon icon-eye'></i></NavLink></td>
                                        <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                        <td>Ramesh_91123456789</td>
                                        <td>Saloni Parihar</td>
                                    </tr>
                                    <tr>
                                        <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                        <td>4</td>
                                        <td>HDFC</td>
                                        <td>HDFC_Worli &nbsp; <NavLink className="text-decoration-none"><i className='icon icon-eye'></i></NavLink></td>
                                        <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                        <td>Ramesh_91123456789</td>
                                        <td>Saloni Parihar</td>      
                                    </tr>
                                    <tr>
                                        <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td>
                                        <td>5</td>
                                        <td>HDFC</td>
                                        <td>HDFC_Worli &nbsp; <NavLink className="text-decoration-none"><i className='icon icon-eye'></i></NavLink></td>
                                        <td>4141 Rockside Rd Suite 410, Seven Hills, OH 44131, United States</td>
                                        <td>Ramesh_91123456789</td>
                                        <td>Saloni Parihar</td>    
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </div>    
        </Container>
    </section>
  )
}

export default ClientTable
